import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import React, { useEffect } from "react";
import { FaChevronLeft } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";
import Seo from "../components/Seo";
import { ScrollToTopSnap } from "../components/ScrollToTop";
import { getHistory } from "../store/slices/HistorySlice";
import historyCover640 from "../assets/images/website-2026/club-history-cover-640.webp";
import historyCover1280 from "../assets/images/website-2026/club-history-cover-1280.webp";

const ClubHistory = () => {
  const dispatch = useDispatch();
  const { history } = useSelector((state) => state.history);

  useEffect(() => {
    dispatch(getHistory());
    ScrollToTopSnap(0);
  }, [dispatch]);

  return (
    <>
      <Seo
        title="Our History"
        path="/club-info/clubhistory"
        image="/social/history.jpg"
        description="The story of Sporting Lagos FC, from our founding to landmark victories and the community behind the club."
      />

      <main className="clubhistory">
        <div className="top">
          <div className="img">
            <picture>
              <source media="(max-width: 700px)" srcSet={historyCover640} />
              <img
                src={historyCover1280}
                alt="Sporting Lagos celebrating a championship"
                width="1280"
                height="853"
                fetchPriority="high"
                decoding="async"
              />
            </picture>
          </div>
          <div className="title">
            <Link className="back-to-prev" to="/club-info">
              <div>
                <FaChevronLeft className="icon" />
                <span>CLUB INFORMATION</span>
              </div>
            </Link>
            <h1>OUR HISTORY</h1>
          </div>
        </div>
        <div className="content-container">
          <div className="content">
            <div className="body-text">
              {history?.[0]?.fields?.history ? (
                documentToReactComponents(history[0].fields.history)
              ) : (
                <div className="commerce-loader">
                  <Loader />
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ClubHistory;
